import moment from 'moment'
import { bool, string, object, func } from 'prop-types'
import { useRef, useEffect } from 'react'
import { kuiperClassNames, kuiperClassNamesWithTracking } from '../../../utils'

import './styles.scss'

const Day = ({
  allowable,
  classPrefix = '',
  date = moment(),
  format = 'D',
  onClick,
  refDate = moment(),
  selected,
}) => {
  const buttonRef = useRef(null)
  const focusedDate =
    refDate && refDate.isSame(date, 'day') ? selected : refDate
  const classes = kuiperClassNamesWithTracking(`${classPrefix}-dayCell`, {
    today: date.isSame(moment(), 'day'),
    sameWeek: date.isSame(refDate, 'week'),
    sameMonth: date.isSame(refDate, 'month'),
    sameYear: date.isSame(refDate, 'year'),
    weekDay: date.weekday() === 0 || date.weekday() === 6,
    selected: onClick && selected,
    clickable: onClick,
    forbidden: !allowable(date),
    highlighted: !focusedDate,
    tracking: 'date',
  })
  const clickHandler = onClick ? onClick.bind(this, date) : undefined

  useEffect(() => {
    if (buttonRef.current) {
      if (!focusedDate) {
        buttonRef.current.focus()
      } else buttonRef.current.blur()
    }
  }, [buttonRef, focusedDate])

  let tabIndex = -1
  if (allowable(date) && (!focusedDate || selected)) {
    tabIndex = 0
  }

  return (
    <td className={classes}>
      <button
        ref={buttonRef}
        aria-pressed={selected}
        className={kuiperClassNames(`${classPrefix}-day`)}
        onClick={clickHandler}
        tabIndex={tabIndex}
        type="button"
      >
        <span aria-hidden={true}>{date.format(format)}</span>
        <span className="sr-only">{date.format('D MMMM')}</span>
      </button>
    </td>
  )
}

Day.propTypes = {
  allowable: func,
  classPrefix: string,
  date: object,
  format: string,
  highlighted: bool,
  onClick: func,
  refDate: object,
  selected: bool,
}

export default Day
